var u = (t) => {
  throw TypeError(t);
};
var y = (t, e, o) => e.has(t) || u("Cannot " + o);
var a = (t, e, o) => (y(t, e, "read from private field"), o ? o.call(t) : e.get(t)), O = (t, e, o) => e.has(t) ? u("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, o), m = (t, e, o, n) => (y(t, e, "write to private field"), n ? n.call(t, o) : e.set(t, o), o);
const R = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var p = /* @__PURE__ */ ((t) => (t.ContactPreference = "contactPreference", t.CreditScore = "creditScore", t.DownPayment = "downPayment", t.Email = "email", t.FirstName = "firstName", t.LastName = "lastName", t.MonthlyPayment = "monthlyPayment", t.OfferId = "offerId", t.PaymentOption = "paymentOption", t.Phone = "phone", t.Series = "series", t.SeriesYear = "seriesYear", t.Term = "term", t.TradeInValue = "tradeInValue", t.Trim = "trim", t.TrimCode = "trimCode", t))(p || {});
const A = [
  "firstName",
  "lastName",
  "phone",
  "email",
  "contactPreference"
  /* ContactPreference */
];
var f = /* @__PURE__ */ ((t) => (t.LOCAL_STORAGE = "localStorage", t.SESSION_STORAGE = "sessionStorage", t))(f || {});
const k = "TOYOTANATIONAL_ENSIGHTEN_PRIVACY_FunctionalCookies", P = "cdl-hint", w = () => document.cookie, L = (t) => {
  const e = w().split(";").filter((o) => o.trim().startsWith(`${t}=`));
  return e.length ? e[e.length - 1].trim().substring(t.length + 1) : null;
}, b = () => ({
  disableAll: L(k) === "0"
}), d = (t) => {
  const e = [];
  for (const o of Object.keys(t)) {
    let n;
    const s = o.split("-");
    if (s.length === 3) {
      const [i, r, l] = s;
      (/* @__PURE__ */ new Date(+l)).toUTCString() !== "Invalid Date" && (n = {
        key: o,
        site: i,
        pod: r,
        timestamp: l
      });
    }
    n && e.push(n);
  }
  return e.sort((o, n) => +n.timestamp - +o.timestamp), e;
}, H = () => ({
  localStorageKeys: d(localStorage),
  sessionStorageKeys: d(sessionStorage)
}), T = {
  mirai: ["SOC", "NCA"]
}, D = (t, e) => !t || !e || !T[e] || T[e].includes(t), C = (t, e, o) => {
  let n;
  for (const s of t) {
    const i = JSON.parse(e.getItem(s.key));
    !n && D(o, i[p.Series]) && (n = i);
  }
  return n ?? {};
}, G = ({ localStorageKeys: t, sessionStorageKeys: e }, o) => {
  let n;
  try {
    const s = C(t, localStorage, o), i = C(e, sessionStorage, o), r = {
      ...s,
      ...i
    };
    Object.keys(r).length && (n = r);
  } catch {
  }
  return n;
}, K = (t, e) => {
  if (t === f.LOCAL_STORAGE)
    for (const [o, n] of Object.entries(e)) {
      const s = o;
      A.includes(s);
    }
  return e;
}, N = console, v = (t) => (e, o, n, s) => {
  var i;
  if (!((i = o.options) != null && i.disableAll))
    try {
      const r = Date.now(), { site: l, pod: E } = o, S = `${l}-${E}-${r}`, g = K(s, e);
      if (t) {
        const h = window == null ? void 0 : window.parent;
        if (h) {
          const I = JSON.stringify({ event: P, key: S, data: g, storage: s }), _ = document.referrer;
          h.postMessage(I, _);
        }
      } else
        n.setItem(S, JSON.stringify(g));
    } catch (r) {
      t ? N.error("Failed to create data for postMessage", r) : N.error(`Failed to set item in ${s}:`, r);
    }
};
var c;
class j {
  constructor(e) {
    O(this, c);
    this.hintFn = v(window.self !== window.top), m(this, c, {
      site: (e == null ? void 0 : e.site) ?? "tcom",
      pod: (e == null ? void 0 : e.pod) ?? "",
      options: {
        ...b(),
        ...(e == null ? void 0 : e.options) ?? {}
      }
    });
  }
  // Stores a session hint in localStorage.
  hint(e) {
    this.hintFn(e, a(this, c), localStorage, f.LOCAL_STORAGE);
  }
  // Stores a session hint in sessionStorage.
  sessionHint(e) {
    this.hintFn(e, a(this, c), sessionStorage, f.SESSION_STORAGE);
  }
  profile() {
    var n, s;
    let e;
    if ((n = a(this, c).options) != null && n.disableAll)
      return e;
    const o = H();
    return e = G(o, (s = a(this, c).options) == null ? void 0 : s.tdaCode), e;
  }
}
c = new WeakMap();
export {
  R as CDLTypes,
  j as DataLayer,
  p as Field,
  A as PIIFields,
  f as StorageType
};
